import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { Pressable, ScrollView, StyleSheet, TextInput as RNTextInput, View } from 'react-native';
import { BasicScrollView } from "@/components/BasicScrollView";
import { ArrowIcon, Button as Button95, Checkbox, Hourglass, NumberInput, Panel, Text, TextInput } from 'react95-native-rabbl';
import Head from 'expo-router/head';
import { CustomText } from '@/components/CustomText';
import Footer from '@/components/Footer';
import * as AppUtilities from "@/utilities/AppUtilities";
import * as AppUtils from '@/utilities/AppUtils';
import * as AppConstants from "@/utilities/AppConstants";
import * as AppConsts from "@/utilities/AppConsts";
import { useForm, Controller, Resolver } from "react-hook-form";
import { AppContext } from '@/components/AppContext';
import { CommunityMembership } from "@/types/community_membership";
import { RelativePathString, useLocalSearchParams, useRouter } from 'expo-router';
import type { RootState } from '@/state/store';
import { useSelector, useDispatch } from 'react-redux';
import { setData } from '@/state/user';
import { Meta } from '@/components/Meta';
import { AppText } from '@/components/AppText';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 20,
    paddingTop: 10,
    gap: 20,
    backgroundColor: 'transparent',
    alignItems: 'center',
  },
  formElement: {
    width: AppConsts.BASIC_MINIMUM_WIDTH,
  },
  buttonWrapper: {
    flexDirection: 'row',
  },
  panel: {
    padding: 20,
    gap: 20,
    alignItems: 'center',
    minWidth: AppConsts.BASIC_MINIMUM_WIDTH,
    maxWidth: AppConsts.MAX_WIDTH_COMFORTABLE_READING,
  },
  numericWrapper: {
    flexDirection: 'row',
    gap: 5,
  },
  numeric: {
    width: 80,
  },
});

export default function Desires() {
  const domain = useSelector((state: RootState) => state.user.domain);
  const { showSpinner, hideSpinner } = useContext(AppContext);
  const router = useRouter();
  const user_info = useSelector((state: RootState) => state.user.user_info);
  const [desireMen, setDesireMen] = useState(user_info.desire_men ?? false);
  const [desireWomen, setDesireWomen] = useState(user_info.desire_women ?? false);
  const dispatch = useDispatch();
  const { edit } = useLocalSearchParams<{ edit?: string }>();

  const onSubmit = useCallback(async() => {
    try {
      showSpinner();

      if (!desireMen && !desireWomen) {
        throw new Error('Choose one');
      }

      const response = await AppUtilities.fetchAuthorized(
        "Desires.onSubmit",
        "/rabbl/api/set_desires",
        "POST",
        {
          domain: domain,
          desire_men: desireMen,
          desire_women: desireWomen,
        }
      );
      const membership: CommunityMembership = ((response as any).body as any).community_membership;
      dispatch(setData(response));

      if (edit && edit.length > 0 && router.canGoBack()) {
        router.back();
      } else {
        router.navigate(AppUtils.getProfileCreateNextPageLink(membership) as RelativePathString);
      }

    } catch (e) {
      AppUtils.showErrorToast(AppUtilities.getErrors(e), () => onSubmit(), true);
      AppUtilities.handleException(e, "Desires.onSubmit");
    } finally {
      hideSpinner();
    }
  }, [domain, desireMen, desireWomen]);

  return (
    <BasicScrollView center={true}>
      <Meta title={"Desires"} />
            
      <Panel variant='raised' elevation={4}>
        <View style={styles.panel}>

          <AppText>Who do you want?</AppText>

          <Checkbox
            status={desireWomen ? 'checked' : 'unchecked'}
            onPress={() => setDesireWomen(desireWomen ? false : true)}
            label='Women'
          />

          <Checkbox
            status={desireMen ? 'checked' : 'unchecked'}
            onPress={() => setDesireMen(desireMen ? false : true)}
            label='Men'
          />

          <View style={styles.buttonWrapper}>
            <Button95 onPress={onSubmit} disabled={!desireMen && !desireWomen}>{ edit ? "Save" : "Next" }</Button95>
          </View>
        </View>
      </Panel>
      
      <Footer />
    </BasicScrollView>
  );
}
